export const USED_AS_SPA = "false" === 'true';
export default environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp.com',
          MAIN_APP: 'https://www.datacamp.com',
          SPREADSHEETS_API: 'https://spreadsheets.datacamp.com/api/v1'
        }
      };
    case 'LOCAL':
    case 'DEVELOPMENT':
    case 'TEST':
    case 'STAGING':
    default:
      return {
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          MAIN_APP: 'https://www.datacamp-staging.com',
          SPREADSHEETS_API: 'https://spreadsheets.datacamp-staging.com/api/v1'
        }
      };
  }
};